import React from 'react';
import { Box, Chip, Switch, Tooltip, Typography, alpha } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';

const ReportExclusionToggle = ({ checked, onChange, disabled }) => (
  <Box
    sx={(theme) => ({
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      flexWrap: 'wrap',
      px: 1.75,
      py: 1,
      mb: 1.5,
      borderRadius: 2.5,
      border: '1px solid',
      borderColor: checked ? theme.palette.error.main : 'divider',
      backgroundColor: checked ? alpha(theme.palette.error.main, 0.07) : '#fff',
      transition: 'all 140ms ease',
    })}
  >
    <BlockIcon
      fontSize="small"
      sx={{ color: checked ? 'error.main' : 'text.disabled' }}
    />
    <Box sx={{ flex: '1 1 260px', minWidth: 240 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 800, lineHeight: 1.3 }}>
        Exclude Orders
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Drops every record whose content type is Order or Orders, from the table, the tiles, the
        charts and the Excel and PDF exports.
      </Typography>
    </Box>
    {checked && (
      <Chip
        size="small"
        color="error"
        label="Applied to exports too"
        sx={{ fontWeight: 700 }}
      />
    )}
    <Tooltip title="Re-runs the report without Order content types">
      <span>
        <Switch
          color="error"
          checked={checked}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked)}
        />
      </span>
    </Tooltip>
  </Box>
);

export default ReportExclusionToggle;
